import { gql } from 'apollo-boost';

export const GET_BANNED_USERS = gql`
  query getBannedUsers {
    bannedUsers {
      _id
      nickname
      avatarUrl
      endDate
      isAnom
    }
  }
`;

export const GET_BANNED_ANOM_USERS = gql`
  query getBannedAnomUsers {
    bannedAnomUsers {
      _id
      nickname
      avatarUrl
      endDate
      isAnom
    }
  }
`;

export const BAN_USER = gql`
  mutation banUser($_id: ID!, $endDate: String!, $isAnom: Boolean, $reason: String) {
    banUser(_id: $_id, endDate: $endDate, isAnom: $isAnom, reason: $reason) {
      _id
      nickname
      avatarUrl
      endDate
      isAnom
    }
  }
`;

export const UN_BAN_USER = gql`
  mutation unBanUser($_id: ID!, $isAnom: Boolean, $reason: String) {
    unBanUser(_id: $_id, isAnom: $isAnom, reason: $reason) {
      _id
    }
  }
`;

export const GET_BAN_HISTORY = gql`
  query banHistory($userId: ID!, $source: BanHistorySource!, $cursor: String) {
    banHistory(userId: $userId, source: $source, cursor: $cursor) {
      nextCursor
      entries {
        id
        occurredAt
        action
        isAnom
        operator
        reason
        previousEndDate
        endDate
        reportId
      }
    }
  }
`;

export const CLEAR_EXPIRED_BANS = gql`
  mutation clearExpiredBans {
    clearExpiredBans
  }
`;
